import axios from 'axios';
import AxiosLoader from '@/libs/AxiosLoader';
import { isEmpty } from 'lodash';

const cifraClient =  axios.create();
let loader = null;

function configurar(options) {
  loader = new AxiosLoader(cifraClient, options);
  loader.load();
}

// Si está arrancado en el puerto de desarrollo de Vite, ponemos la URL base apuntando a
// la de desarrollo de Rails
function activarDesarrollo(window) {
  const url = new URL(window.location.href);
  if (url.port === '3001' || url.port === '5173') {
    cifraClient.defaults.baseURL = 'http://127.0.0.1:3000/';
  }
}

export function useCifraClient() {
  return {
    cifraClient,
    configurar,
    activarDesarrollo,
  };
}

export function createOrUpdate(cliente, urlBase, objectData, options = {}) {
  let method = 'post';
  let url = urlBase;
  let data = {};
  if (!!options.namespace) {
    data[options.namespace] = objectData;
  } else {
    data = { ...objectData }
  }
  if (!!objectData.id) {
    url = `${url}/${objectData.id}`;
    method = 'patch';
  }
  const config = Object.assign({
    method,
    url,
    data
  }, options);
  return cliente.request(config);
}
